module.exports = __webpack_public_path__ + "media/personal_finance/title-c8507e97.png";